"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseRetailEventTrackingHandler = void 0;
const React = require("react");
const firebase = require("firebase/app");
const RetailEventTrackingContext_1 = require("../../contexts/RetailEventTrackingContext");
const useClient_1 = require("../../../../../hooks/useClient");
const react_1 = require("react");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const FirebaseContext_1 = require("../../../../../contexts/FirebaseContext");
const createCartEventObject_1 = require("../../helpers/analytics/createCartEventObject");
const createTransactionEventObject_1 = require("../../helpers/analytics/createTransactionEventObject");
const createPurchaseEventObject_1 = require("../../helpers/analytics/createPurchaseEventObject");
/**
 * Handles sending tracking events to Firebase for the purpose of tracking analytics withing the ordering applications.
 */
const FirebaseRetailEventTrackingHandler = ({ children }) => {
    const client = (0, useClient_1.useClient)();
    const { logEvent, setUserId } = (0, useRequiredContext_1.useRequiredContext)(FirebaseContext_1.FirebaseContext);
    // set the current user who we are tracking events for if they are logged in
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        const userId = ((_c = (_b = (_a = client.auth) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.retailCustomer) === null || _c === void 0 ? void 0 : _c.retailCustomerId) || null;
        setUserId(userId);
    }, [client.auth.session]);
    /**
     * This is the event logged when the customer clicks purchase now. This is just before they complete the order.
     * With this we can track how many customer don't actually complete their order.
     */
    const logBeginCheckout = (salesOrderItems, totalPrice) => {
        const eventName = firebase.analytics.EventName.BEGIN_CHECKOUT;
        const eventData = (0, createCartEventObject_1.createCartEventObject)(salesOrderItems, totalPrice);
        logEvent(eventName, eventData);
    };
    /**
     * Event logged when a successful sales order is made. We track important details of the sales includes location, customer, items
     * ordered, promotions, price etc.
     */
    const logTransaction = (salesOrder) => {
        const eventName = "transaction";
        const eventData = (0, createTransactionEventObject_1.createTransactionEventObject)(salesOrder);
        logEvent(eventName, eventData);
    };
    /**
     * Add purchase event to make it compatibale with GA4
     */
    const logPurchase = (salesOrder) => {
        const eventName = "purchase";
        const eventData = (0, createPurchaseEventObject_1.createPurchaseEventObject)(salesOrder, "web");
        logEvent(eventName, eventData);
    };
    /**
     * Event logged when a new user has signed up. We use this to analyze what devices people are signing up from.
     */
    const logSignUp = (method) => {
        const eventName = firebase.analytics.EventName.SIGN_UP;
        const eventData = {
            method
        };
        logEvent(eventName, eventData);
    };
    /**
     * This is the event logged when the customer views their cart before checkout.
     * With this we can track the flow of customers going throught the checkout process and whether they complete it.
     */
    const logViewCart = (salesOrderItems, totalPrice) => {
        const eventName = firebase.analytics.EventName.VIEW_CART;
        const eventData = (0, createCartEventObject_1.createCartEventObject)(salesOrderItems, totalPrice);
        logEvent(eventName, eventData);
    };
    const value = {
        logBeginCheckout,
        logTransaction,
        logPurchase,
        logSignUp,
        logViewCart
    };
    return (React.createElement(RetailEventTrackingContext_1.RetailEventTrackingContext.Provider, { value: value }, children));
};
exports.FirebaseRetailEventTrackingHandler = FirebaseRetailEventTrackingHandler;
//# sourceMappingURL=index.js.map